import styled from '@emotion/styled'
import { calcRem, colors, breakpointMax } from '../../__styling'
import { themedValue } from '../../__styling/themed-value'

export const VerticalVideoWrapper = styled('div')(({ theme }) => ({
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: themedValue(theme, {
        sevennews: colors.black,
        fallback: colors.black,
    }),

    // center video vertically + horizontally
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: calcRem(57),
        pointerEvents: 'none',
        zIndex: 2,
        background:
            'linear-gradient(to bottom, rgba(0,0,0,0.55), rgba(0,0,0,0))',
    },

    '.video-js': {
        width: '100%',
    },

    '.video-specificity .video-js video.vjs-tech': {
        backgroundColor: colors.black,
        height: '100%',
        left: '50%',
        objectFit: 'cover',
        transform: 'translateX(-50%)',
        [breakpointMax('sm')]: {
            '@media (max-aspect-ratio: 9/16)': {
                objectFit: 'contain',
                transform: 'translateX(-50%)',
            },
        },
    },

    '.video-specificity [class*="StyledBrightcoveVideo"] .vjs-control-bar': {
        background: 'transparent',
        bottom: calcRem(-1) + '!important',
        zIndex: 16,
        '& .vjs-time-control': {
            display: 'none',
        },
    },

    '.video-specificity [class*="StyledBrightcoveVideo"] .vjs-custom-control-spacer':
        {
            display: 'none',
        },

    '.VerticalVideoTapOverlay': {
        position: 'absolute',
        inset: 0,
        zIndex: 2,
        cursor: 'pointer',
    },

    '.Play-Overlay:hover': {
        background: 'transparent',
    },

    '& [class*="StyledUnmuteButton"] ': {
        top: calcRem(10) + '!important',
        left: 'auto',
        right: calcRem(16),
        zIndex: 3,
    },
}))
